export default __webpack_public_path__ + "static/media/Poppins-SemiBoldItalic.0ab4ff67.ttf";